import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseDailyUserRecommendZnCurriculumUnits } from '@/api/responses/dailyUserRecommendZnCurriculumUnits'

export namespace DailyUserRecommendZnCurriculumUnitsApi {
  /**
   * おすすめ単元取得
   *
   * @param subjectCode 教科コード
   * @returns おすすめ単元一覧
   */
  export async function getDailyUserRecommendZnCurriculumUnits(
    subjectCode: string
  ): Promise<ApiResponseDailyUserRecommendZnCurriculumUnits | null> {
    return await ApiBase.getWithAccepted(`dailyUserRecommendZnCurriculumUnits/${subjectCode}`)
  }
}
